import { NavigateAction } from 'reducers/Navigation';
import { call, takeEvery } from 'redux-saga/effects';
import history from '../../history';
import { Type as navigationTypes } from '../../reducers/Navigation';

export function* navigate({ href }: NavigateAction) {
  if (href) {
    try {
      yield call(history.push, href);
    } catch (error) {
      yield call(
        console.error,
        `Hit an error when trying to navigate to ${href}`
      );
    }
  } else {
    yield call(
      console.error,
      'Unable to navigate to an empty or undefined href'
    );
  }
}

export function* navigationSaga() {
  yield takeEvery(navigationTypes.NAVIGATE, navigate);
}
